import React from 'react';

class TermsAndConditions extends React.Component {
  handleBack = () => {
    if (this.props.history) {
      this.props.history.goBack();
    } else {
      window.history.back();
    }
  };

  render() {
    return (
      <div style={containerStyle}>
        {/* --- FIXED APP TOOLBAR --- */}
        <div style={toolbarStyle}>
          <button onClick={this.handleBack} style={iconButtonStyle}>
            ←
          </button>
          <div style={toolbarTitleStyle}>Terms & Conditions</div>
          <div style={{ width: '40px' }}></div>{' '}
          {/* Spacer to center the title */}
        </div>

        <div style={cardStyle}>
          {/* Header Section */}
          <header style={headerStyle}>
            <h1 style={titleStyle}>Terms and Conditions</h1>
            <p style={{ ...dateStyle, fontStyle: 'italic' }}>
              Last Updated: June 19, 2026
            </p>
          </header>

          {/* Content Section */}
          <div style={contentStyle}>
            <section style={sectionStyle}>
              <h2 style={headingStyle}>1. Acceptance of Terms</h2>
              <p>
                Welcome to <strong>NuVe System</strong>. These Terms and
                Conditions ("Terms") govern your use of the NuVe System mobile
                application (the "App") operated by NUVE SYSTEM LLC ("we,"
                "our," or "us").
              </p>
              <p>
                By accessing or using the App, you agree to be bound by these
                Terms. If you do not agree to these Terms, please do not use the
                App.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>2. Description of Service</h2>
              <p>
                NuVe System is a business management application designed to
                help operators of client-based businesses organize and manage
                their customer base and oversee daily business activity from a
                centralized platform.
              </p>
              <p>The App provides the following functionality:</p>
              <ul style={listStyle}>
                <li>Customer profile management and data organization</li>
                <li>
                  Membership tracking and check-in system using phone numbers
                </li>
                <li>Loyalty points and customer activity tracking</li>
                <li>
                  Internal business record keeping and workflow management
                </li>
              </ul>
              <div style={importantNoticeStyle}>
                <strong>Important:</strong> NuVe System is strictly an
                administrative tool. It does not operate equipment, process
                customer financial transactions, or facilitate payments. Any
                payments processed through the app are exclusively for
                subscription plans and license renewals for business owners'
                access to the software itself.
              </div>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>
                2A. Software Provider Status and Liability Limitations
              </h2>
              <p>
                <strong>Independent Business Operations:</strong> NuVe System is
                a software and data management platform provided to
                independently owned and operated businesses. NUVE SYSTEM LLC
                does not own, operate, manage, or control any physical business
                locations, facilities, or establishments that use the App.
              </p>

              <p>
                <strong>No Control Over Business Decisions:</strong> NuVe System
                does not make, control, influence, or participate in any
                business operator's decisions regarding:
              </p>
              <ul style={listStyle}>
                <li>Customer admission or entry to physical locations</li>
                <li>Membership requirements or eligibility criteria</li>
                <li>Service provision or denial</li>
                <li>Access policies or operational rules</li>
                <li>Customer relationship management practices</li>
              </ul>

              <p>
                <strong>Phone Number Technical Requirement:</strong> The App
                requires a valid phone number as a technical requirement for
                user authentication and login functionality. This requirement is
                inherent to the system's design and security architecture,
                enabling secure identity verification through SMS-based one-time
                codes. Each business operator independently decides whether and
                how to implement customer registration requirements within their
                establishment.
              </p>

              <p>
                <strong>Business Operator Responsibility:</strong> Any and all
                policies, practices, rules, or decisions related to customer
                entry, service, membership enforcement, or access control are
                the sole responsibility of the individual business operator
                using the App. Business operators are independent third parties
                who maintain complete autonomy over their business operations
                and customer policies.
              </p>

              <p>
                <strong>Limitation of Liability:</strong> NUVE SYSTEM LLC and
                NuVe System are not liable for, and expressly disclaim any
                responsibility for:
              </p>
              <ul style={listStyle}>
                <li>
                  How business operators apply membership or access policies
                </li>
                <li>
                  Business operators' decisions regarding customer admission or
                  service
                </li>
                <li>Any disputes between customers and business operators</li>
                <li>
                  Business operators' compliance with applicable laws and
                  regulations
                </li>
                <li>
                  Any actions, policies, or practices of business operators
                  using the App
                </li>
              </ul>

              <p>
                <strong>Third-Party Responsibility:</strong> Users acknowledge
                and agree that business operators using NuVe System are
                independent third parties, and that NUVE SYSTEM LLC's sole role
                is to provide software tools for data management and business
                administration.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>3. User Eligibility</h2>
              <p>The App is intended for use by:</p>
              <ul style={listStyle}>
                <li>
                  Business operators and their authorized staff members who
                  manage customer data
                </li>
                <li>
                  Customers of participating businesses who provide their
                  information for membership purposes
                </li>
              </ul>
              <p>
                You must be at least <strong>18 years of age</strong> to use
                this App. By using the App, you represent and warrant that you
                meet this age requirement.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>4. No User Accounts</h2>
              <p>
                NuVe System does not create traditional user accounts with
                usernames and passwords. Customers identify themselves using
                their phone number when visiting participating business
                locations. All customer data is managed by business operators
                through the App's administrative interface.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>5. Data Collection and Privacy</h2>
              <p>
                By using the App or providing your information at a
                participating business location, you acknowledge and agree that
                we collect and process personal information as described in our
                Privacy Policy, including:
              </p>
              <ul style={listStyle}>
                <li>Full legal name</li>
                <li>Phone number</li>
                <li>Date of birth</li>
                <li>Address</li>
                <li>Driver's license number</li>
                <li>Points and membership information</li>
                <li>Registration details and comments</li>
              </ul>
              <p>
                Please review our Privacy Policy for detailed information about
                how we collect, use, and protect your data.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>
                5A. SMS / Text Messaging Program Terms
              </h2>
              <p>
                NuVe System sends two categories of text messages, each subject
                to its own consent:
              </p>
              <ul style={listStyle}>
                <li>
                  <strong>Account &amp; Verification Messages:</strong> One-time
                  verification codes (OTP) and membership/account notifications
                  required to verify your identity and provide access to
                  membership features. You consent to these messages when you
                  accept the Phone Verification notice during check-in or
                  membership activation.
                </li>
                <li>
                  <strong>
                    Member Benefits &amp; Promotional Messages (optional):
                  </strong>{' '}
                  Recurring promotional offers, special event announcements,
                  loyalty program updates, membership rewards, and other updates
                  about your NuVe System membership and participating NuVe
                  System locations. These messages are sent{' '}
                  <strong>only</strong> if you expressly opt in by checking the
                  separate Member Benefits &amp; Promotions consent box.
                </li>
              </ul>
              <p>
                The NuVe System SMS loyalty and messaging program is operated by{' '}
                <strong>NUVE SYSTEM LLC</strong>. When you opt in, you consent
                to receive these messages from NUVE SYSTEM LLC.
              </p>
              <p>
                <strong>
                  Message frequency varies. Message and data rates may apply.
                </strong>{' '}
                Consent to receive promotional messages is <strong>not</strong>{' '}
                a condition of membership, check-in, or any purchase.
              </p>
              <p>
                <strong>Opt out:</strong> Reply <strong>STOP</strong> to any
                promotional message to cancel promotional messages at any time,
                or update your communication preferences with the business
                location. After you send STOP, you will receive a single
                confirmation message and no further promotional messages will be
                sent. <strong>Help:</strong> Reply <strong>HELP</strong> to any
                message or contact info@nuvesystem.com for assistance.
              </p>
              <p>
                <strong>Carrier Disclaimer:</strong> Wireless carriers are not
                liable for delayed or undelivered messages. Message delivery is
                subject to effective transmission by your mobile carrier and is
                outside our control.
              </p>
              <p>
                Mobile phone numbers and SMS opt-in consent will not be shared
                with, sold to, or rented to any third parties or affiliates for
                their own marketing or promotional purposes. For full details on
                how mobile information is handled, see our Privacy Policy.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>6. User Responsibilities</h2>
              <p>When using the App, you agree to:</p>
              <ul style={listStyle}>
                <li>Provide accurate, current, and complete information</li>
                <li>
                  Maintain the accuracy of your information and promptly update
                  any changes
                </li>
                <li>
                  Use the App only for lawful purposes and in compliance with
                  these Terms
                </li>
                <li>
                  Not attempt to gain unauthorized access to the App or its
                  systems
                </li>
                <li>
                  Not use the App in any way that could damage, disable, or
                  impair the service
                </li>
                <li>
                  Not attempt to interfere with the proper working of the App
                </li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>
                7. Business Operator Responsibilities
              </h2>
              <p>Business operators using the App agree to:</p>
              <ul style={listStyle}>
                <li>Use customer data only for legitimate business purposes</li>
                <li>
                  Maintain the confidentiality and security of customer
                  information
                </li>
                <li>
                  Comply with all applicable data protection and privacy laws
                </li>
                <li>
                  Obtain necessary consent from customers before collecting
                  their information
                </li>
                <li>
                  Send promotional text messages only to customers who have
                  expressly opted in, and honor all STOP requests immediately
                </li>
                <li>
                  Handle customer data requests (access, correction, deletion)
                  appropriately
                </li>
                <li>
                  Not share or sell customer data to unauthorized third parties
                </li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>8. Intellectual Property</h2>
              <p>
                The App and its entire contents, features, and functionality
                (including but not limited to all information, software, text,
                displays, images, and the design, selection, and arrangement
                thereof) are owned by NUVE SYSTEM LLC and are protected by
                United States and international copyright, trademark, patent,
                trade secret, and other intellectual property laws.
              </p>
              <p>
                You may not reproduce, distribute, modify, create derivative
                works of, publicly display, republish, download, store, or
                transmit any of the material in our App without our prior
                written consent.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>9. Prohibited Uses</h2>
              <p>You may not use the App:</p>
              <ul style={listStyle}>
                <li>
                  In any way that violates any applicable federal, state, local,
                  or international law or regulation
                </li>
                <li>
                  To transmit, or procure the sending of, any advertising or
                  promotional material without our prior written consent
                </li>
                <li>
                  To impersonate or attempt to impersonate NUVE SYSTEM LLC, a
                  NUVE SYSTEM LLC employee, another user, or any other person or
                  entity
                </li>
                <li>
                  To engage in any conduct that restricts or inhibits anyone's
                  use or enjoyment of the App
                </li>
                <li>
                  To collect or track the personal information of others without
                  authorization
                </li>
                <li>For any fraudulent or malicious purpose</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>
                10. Service Modifications and Availability
              </h2>
              <p>We reserve the right to:</p>
              <ul style={listStyle}>
                <li>
                  Modify or discontinue, temporarily or permanently, the App (or
                  any part of it) with or without notice
                </li>
                <li>
                  Change these Terms at any time by posting the revised Terms on
                  this page
                </li>
                <li>
                  Refuse service, terminate accounts, or remove or edit content
                  at our sole discretion
                </li>
              </ul>
              <p>
                We do not guarantee that the App will always be available or be
                uninterrupted. We may experience hardware, software, or other
                problems or need to perform maintenance related to the App,
                resulting in interruptions, delays, or errors.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>11. Disclaimer of Warranties</h2>
              <p style={capsStyle}>
                THE APP IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS
                WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED,
                INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR COURSE OF
                PERFORMANCE.
              </p>
              <p>NUVE SYSTEM LLC DOES NOT WARRANT THAT:</p>
              <ul style={listStyle}>
                <li>
                  The App will function uninterrupted, secure, or available at
                  any particular time or location
                </li>
                <li>Any errors or defects will be corrected</li>
                <li>The App is free of viruses or other harmful components</li>
                <li>
                  The results of using the App will meet your requirements
                </li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>12. Limitation of Liability</h2>
              <p style={capsStyle}>
                TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL NUVE
                SYSTEM LLC, ITS AFFILIATES, OR THEIR LICENSORS, SERVICE
                PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, OR DIRECTORS BE LIABLE
                FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF
                OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE APP,
                INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL,
                CONSEQUENTIAL, OR PUNITIVE DAMAGES.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>13. Indemnification</h2>
              <p>
                You agree to defend, indemnify, and hold harmless NUVE SYSTEM
                LLC, its affiliates, licensors, and service providers, and its
                and their respective officers, directors, employees,
                contractors, agents, licensors, suppliers, successors, and
                assigns from and against any claims, liabilities, damages,
                judgments, awards, losses, costs, expenses, or fees (including
                reasonable attorneys' fees) arising out of or relating to your
                violation of these Terms or your use of the App.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>14. Governing Law and Jurisdiction</h2>
              <p>
                These Terms shall be governed by and construed in accordance
                with the laws of the United States and the state in which NUVE
                SYSTEM LLC operates, without regard to its conflict of law
                provisions.
              </p>
              <p>
                Any legal action or proceeding arising under these Terms will be
                brought exclusively in the federal or state courts located in{' '}
                <strong>Texas/United States</strong>, and the parties hereby
                consent to personal jurisdiction and venue therein.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>15. Dispute Resolution</h2>
              <p>
                Any dispute arising from these Terms or your use of the App
                shall first be attempted to be resolved through good faith
                negotiations. If negotiations fail, disputes may be resolved
                through binding arbitration in accordance with the rules of the
                American Arbitration Association.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>16. Severability</h2>
              <p>
                If any provision of these Terms is held to be invalid or
                unenforceable, such provision shall be struck and the remaining
                provisions shall remain in full force and effect.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>17. Waiver</h2>
              <p>
                No waiver by NUVE SYSTEM LLC of any term or condition set forth
                in these Terms shall be deemed a further or continuing waiver of
                such term or condition or a waiver of any other term or
                condition.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>18. Entire Agreement</h2>
              <p>
                These Terms, together with our Privacy Policy, constitute the
                sole and entire agreement between you and NUVE SYSTEM LLC
                regarding the App and supersede all prior and contemporaneous
                understandings, agreements, representations, and warranties.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>19. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. We will
                notify you of any changes by posting the new Terms on this page
                and updating the "Last Updated" date.
              </p>
              <p>
                Your continued use of the App after any such changes constitutes
                your acceptance of the new Terms. If you do not agree to the
                modified Terms, you must stop using the App.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>20. Termination</h2>
              <p>
                We may terminate or suspend your access to the App immediately,
                without prior notice or liability, for any reason whatsoever,
                including without limitation if you breach these Terms.
              </p>
              <p>
                Upon termination, your right to use the App will immediately
                cease. All provisions of these Terms which by their nature
                should survive termination shall survive, including ownership
                provisions, warranty disclaimers, indemnity, and limitations of
                liability.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>21. Contact Information</h2>
              <p>
                If you have any questions about these Terms, please contact us
                at:
              </p>
              <div style={contactBoxStyle}>
                NUVE SYSTEM LLC
                <br />
                info@nuvesystem.com
              </div>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>22. Acknowledgment</h2>
              <p>
                BY USING THE APP, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS
                AND AGREE TO BE BOUND BY THEM.
              </p>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

// Styles

const dateStyle = {
  color: '#777',
  fontSize: '0.95rem',
  fontWeight: '400',
};

const contentStyle = {
  textAlign: 'left',
};

const sectionStyle = {
  marginBottom: '35px',
};

const headingStyle = {
  color: '#001665',
  fontSize: '1.3rem',
  marginBottom: '15px',
  fontWeight: '700',
};

const listStyle = {
  paddingLeft: '25px',
  marginBottom: '15px',
};

const importantNoticeStyle = {
  backgroundColor: '#f8f9ff',
  borderLeft: '4px solid #001665',
  padding: '15px 20px',
  marginTop: '15px',
  fontSize: '0.95rem',
  fontStyle: 'italic',
};

const capsStyle = {
  textTransform: 'uppercase',
  fontSize: '0.9rem',
  fontWeight: '600',
  color: '#444',
};

const contactBoxStyle = {
  backgroundColor: '#f4f4f4',
  padding: '20px',
  borderRadius: '8px',
  marginTop: '10px',
  display: 'inline-block',
  minWidth: '250px',
};

const toolbarStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  height: '60px',
  backgroundColor: '#001665',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 15px',
  zIndex: 1000,
  boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
};

const iconButtonStyle = {
  backgroundColor: 'transparent',
  color: 'white',
  border: 'none',
  fontSize: '24px',
  cursor: 'pointer',
  padding: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const toolbarTitleStyle = {
  color: 'white',
  fontSize: '18px',
  fontWeight: '600',
};

const containerStyle = {
  backgroundColor: '#ffffff', // Match your dark blue background
  minHeight: '100vh',
  paddingTop: '80px', // Space for the fixed toolbar
  paddingBottom: '40px',
  paddingLeft: '15px',
  paddingRight: '15px',
  display: 'flex',
  justifyContent: 'center',
  fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
};

const cardStyle = {
  backgroundColor: '#ffffff',
  maxWidth: '900px',
  width: '100%',
  padding: '30px 20px', // Tighter padding for mobile responsiveness
  borderRadius: '12px',
  color: '#333',
  lineHeight: '1.7',
};

const headerStyle = {
  borderBottom: '3px solid #001665',
  marginBottom: '30px',
  paddingBottom: '15px',
};

const titleStyle = {
  color: '#001665',
  fontSize: '1.8rem', // Slightly smaller for mobile compatibility
  margin: '0 0 10px 0',
};

export default TermsAndConditions;
